function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import { CONTACT_SALES_HUBSPOT_FORM_ID } from "client/services/hubspot-service/contact-form-config";
import { StyledHubspotFormComponent } from "./hubspot-form-component.scss";
const HubspotFormComponent = (_param)=>{
    var { formId, disableShadow, horizontalMargin, maxWidth, ctaProps, mobileHorizontalPadding, privacyNoticeText, singleLineFieldBreakpoint } = _param, props = _object_without_properties(_param, [
        "formId",
        "disableShadow",
        "horizontalMargin",
        "maxWidth",
        "ctaProps",
        "mobileHorizontalPadding",
        "privacyNoticeText",
        "singleLineFieldBreakpoint"
    ]);
    const getFormId = ()=>formId || CONTACT_SALES_HUBSPOT_FORM_ID;
    const validScreenWidthForSingleLineField = useMemo(()=>parseInt(singleLineFieldBreakpoint, 10) || null, []);
    return /*#__PURE__*/ _jsx(StyledHubspotFormComponent, {
        className: "hubspot-form-component",
        maxWidth: maxWidth,
        mobileHorizontalPadding: mobileHorizontalPadding,
        singleLineFieldBreakpoint: validScreenWidthForSingleLineField,
        horizontalMargin: horizontalMargin,
        disableShadow: disableShadow,
        children: /*#__PURE__*/ _jsx(HubspotContactForm, _object_spread({
            isV2: true,
            formId: getFormId(),
            ctaProps: ctaProps,
            privacyNoticeText: privacyNoticeText
        }, props))
    });
};
export default HubspotFormComponent;
